var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"nostyle",attrs:{"to":_vm.url}},[_c('div',{staticClass:"objectFilter",class:{selected: _vm.selected}},[_c('h3',[_vm._v(_vm._s(_vm.filter.name))]),_vm._v(" "),(_vm.selected)?_c('div',{staticClass:"deselect"},[_vm._v("x")]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52da6df6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ObjectFilter.vue
// module id = 86
// module chunks = 0